import React, { useState } from "react";
import "./Training.css";
import trainingData from "./Training.json";

export default function TrainingPage() {
    const [activeIndex, setActiveIndex] = useState(0);

    const activeModule = trainingData[activeIndex];

    const handleNext = () => {
        if (activeIndex + 1 < trainingData.length) {
            setActiveIndex(activeIndex + 1);
        }
    };

    return (
        <div className="training-container">

            {/* Sidebar */}
            <aside className="training-sidebar">
                <div className="sidebar-header">Auditusierp Training</div>
                <ul className="sidebar-list">
                    {trainingData.map((item, index) => (
                        <li
                            key={item.id}
                            className={`sidebar-item ${activeIndex === index ? "active" : ""}`}
                            onClick={() => setActiveIndex(index)}
                        >
                            {index + 1}. {item.title}
                        </li>
                    ))}
                </ul>
            </aside>

            {/* Main Content */}
            <main className="training-main">
                <div className="training-card">

                    <h2 className="training-title">{activeModule.title}</h2>

                    <div className="learning-points">
                        <ul>
                            {activeModule.points.map((point, index) => (
                                <li key={index}>{point}</li>
                            ))}
                        </ul>
                    </div>

                    <div className="summary-box">
                        {activeModule.summary}
                    </div>
                    {/* Next Button */}
                    {activeIndex + 1 < trainingData.length && (
                        <div style={{ marginTop: "20px" }}>
                            <button onClick={handleNext} className="training-button">
                                Next Module
                            </button>
                        </div>
                    )}

                </div>
            </main>
        </div>
    );
}